import { ENTERPRISE_ADMIN_BASE } from './adminLayers';

export type CommandDestination = {
  id: string;
  label: string;
  to: string;
  group: string;
  keywords?: string;
};

const E = ENTERPRISE_ADMIN_BASE;

/** Cmd+K navigation targets — enterprise shell + mirrored classic pages under `/admin/app`. */
export const ENTERPRISE_COMMAND_DESTINATIONS: CommandDestination[] = [
  { id: 'overview', label: 'Command overview', to: E, group: 'Overview', keywords: 'home' },
  { id: 'dash', label: 'Ops dashboard', to: `${E}/dashboard`, group: 'Overview', keywords: 'metrics stats' },
  { id: 'users', label: 'Users', to: `${E}/users`, group: 'Directory' },
  { id: 'ws-dir', label: 'Workspace directory', to: `${E}/workspaces`, group: 'Directory', keywords: 'tenants 360' },
  { id: 'ws-table', label: 'Workspaces (table)', to: `${E}/workspaces/table`, group: 'Directory', keywords: 'classic list' },
  { id: 'domains', label: 'Sending domains', to: `${E}/verified-domains`, group: 'Platform', keywords: 'email verified mailgun resend' },
  { id: 'invoices', label: 'Invoices', to: `${E}/invoices`, group: 'Revenue' },
  { id: 'pricing', label: 'Pricing', to: `${E}/pricing`, group: 'Revenue' },
  { id: 'api-keys', label: 'API keys', to: `${E}/api-keys`, group: 'Platform' },
  { id: 'phones', label: 'Phone numbers', to: `${E}/phone-numbers`, group: 'Platform' },
  { id: 'calling', label: 'Calling providers', to: `${E}/calling-providers`, group: 'Platform' },
  { id: 'workflows', label: 'Workflows', to: `${E}/workflows`, group: 'Platform' },
  { id: 'wf-health', label: 'Workflow health', to: `${E}/workflow-health`, group: 'Platform' },
  { id: 'integrations', label: 'Integrations', to: `${E}/integrations`, group: 'Platform' },
  { id: 'settings', label: 'Settings', to: `${E}/settings`, group: 'Settings', keywords: 'configuration' },
  {
    id: 'invoice-templates',
    label: 'Invoice templates',
    to: `${E}/settings/invoice-templates`,
    group: 'Settings',
    keywords: 'pdf invoice branding',
  },
  { id: 'system', label: 'System', to: `${E}/system`, group: 'Reliability' },
  { id: 'monitoring', label: 'Monitoring', to: `${E}/monitoring`, group: 'Reliability' },
  { id: 'fastapi', label: 'FastAPI monitor', to: `${E}/fastapi-monitoring`, group: 'Reliability' },
  { id: 'supabase', label: 'Supabase monitor', to: `${E}/supabase-monitor`, group: 'Reliability' },
  { id: 'audit', label: 'Audit log', to: `${E}/audit`, group: 'Compliance', keywords: 'activity' },
  { id: 'classic', label: 'Classic dashboard (legacy shell)', to: '/admin/dashboard', group: 'Shortcuts', keywords: 'old layout' },
];
